import { prop, compose } from 'ramda';

const theme = compose(prop('theme'));

export { theme };
